<small class="debug">{{me}}</small>
@if (cartProduct) {
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">monetization_on</mat-icon>
        <span class="section-title">{{ 'ai.specialOfferLimitedTime' | transloco }}</span>
        <button mat-icon-button class="close-button" mat-dialog-close [attr.aria-label]="'ai.close' | transloco">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="on-sale-content">
        <app-product [cartProduct]="cartProduct" fxLayout="column" id="{{ 'p_' + cartProduct.product_id }}">
        </app-product>
    </div>
}
